import _ from 'lodash';
import { action, makeObservable } from 'mobx';
import { TaskWithActionViewModel } from 'src/components/FormForTaskWithAction/TaskWithActionViewModel';
import { taskActionHandlers } from 'src/stores/TaskWithActionStore/taskActionHandlers';
import { getTaskAction } from 'src/stores/TaskWithActionStore/TaskActionTypes.types';

export class TaskActionManagerClass {
    constructor() {
        makeObservable(this);
    }

    @action taskActionExecutor(
        taskViewModel: typeof TaskWithActionViewModel,
        formInstance: any,
    ) {
        const taskAction = getTaskAction(taskViewModel.currentTaskDefinition);

        const actionHandler = this.getActionHandler(taskAction);

        actionHandler?.(taskViewModel, formInstance);
    }

    private getActionHandler(action: string) {
        if (!action) return;

        return _.get(taskActionHandlers, action);
    }
}

export const TaskActionManager = new TaskActionManagerClass();
